import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_SOCCORSOGC_API || process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const API_ORIGIN = BACKEND_URL;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sgc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Centralized handling of expired/invalid sessions. On HTTP 401 (except the
// login call itself) we clear the stored session and notify the app so it can
// redirect the operator back to the login page instead of getting stuck on a
// "token non valido" banner.
let onUnauthorized = null;
export const setUnauthorizedHandler = (handler) => { onUnauthorized = handler; };

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !url.includes("/auth/login")) {
      localStorage.removeItem("sgc_token");
      localStorage.removeItem("sgc_username");
      localStorage.removeItem("sgc_role");
      if (onUnauthorized) onUnauthorized();
    }
    return Promise.reject(error);
  }
);

export function apiErrorMessage(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Errore imprevisto";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && d.msg ? d.msg : JSON.stringify(d))).join(" ");
  return String(detail);
}

// Normalize the real SoccorsoGC backend event shape to the shape used by the UI.
export function normalizeEvent(ev) {
  if (!ev) return ev;
  const track = ev.track || null;
  const last = ev.last || (track && track.length ? track[track.length - 1] : null);
  return {
    ...ev,
    number: ev.num ?? ev.number,
    last,
    points_count: ev.points ?? ev.points_count ?? (track ? track.length : 0),
    arrival_ts: ev.created_at ?? ev.arrival_ts,
  };
}

// /operators may return array of strings or array of {username, role}
export function normalizeOperators(data) {
  return (data || []).map((o) => (typeof o === "string" ? o : o.username));
}

export default api;
